import type { HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/utils/classnames';

export type LabelSize = 'large' | 'medium' | 'small' | 'smaller' | 'tiny';
export type LabelWeight = 'regular' | 'bold';

export interface LabelProps extends HTMLAttributes<HTMLElement> {
  /** 타이포그래피 크기 */
  size?: LabelSize;
  /** 폰트 굵기 */
  weight?: LabelWeight;
  /** HTML 태그 (기본값: label) */
  as?: 'label' | 'span' | 'div' | 'p';
}

/**
 * Label 컴포넌트
 *
 * Figma Design System의 Label 스타일을 적용한 레이블 컴포넌트입니다.
 *
 * @example
 * ```tsx
 * <Label size="large" weight="bold">큰 레이블</Label>
 * <Label size="medium">일반 레이블</Label>
 * <Label size="small" weight="bold">작은 레이블</Label>
 * ```
 */
export function Label({
  size = 'medium',
  weight = 'regular',
  as = 'label',
  className,
  children,
  ...props
}: LabelProps) {
  const Component = as;
  const sizeClass =
    size === 'tiny' ? 'label-tiny' : `label-${size}${weight === 'bold' ? '-b' : ''}`;

  return (
    <Component className={cn(sizeClass, className)} {...props}>
      {children}
    </Component>
  );
}
